export enum QuestionType{
    ZERO,
    MULTIPLECHOICE,
    TRUEFALSE,
    LONGFILL,
    LIKERT
}
